import * as $ from "jquery";

export class ScrollFunctions {
    static scrollToId(idToScrollTo, offset) {
        return new Promise((resolve)=>{
            $('html').animate({
                scrollTop: ($("#" + idToScrollTo).offset().top + offset)
            }, 350, ()=>{
                resolve()
            })
        })
    }
    
    static horizontalScrollToIdInDiv(scrolledDivId, divAnchorId , idToScrollTo, offset) {
        let scrollDistance = ($("#" + idToScrollTo).offset().left - $("#"+divAnchorId).offset().left) + offset
        $('#'+scrolledDivId).animate({
            scrollLeft: scrollDistance
        }, 350)
    }

    static scrollToIdInModal(modalId, idToScrollTo, offset) {
        let scrollDistance = ($("#" + idToScrollTo).offset().top - $("#top-modal-anchor").offset().top) + offset
        $('#' + modalId).animate({
            scrollTop: scrollDistance
        }, 350)
    }

    static scrollToTop() {
        $('html').animate({
            scrollTop: 0
        }, 350)
    }
}